import { atom } from 'recoil';
import { RecoilAtomKeys } from '@application/recoils/constants';

export const GlobalLoadingState = atom<boolean>({
  key: RecoilAtomKeys.GLOBAL_LOADING,
  default: false,
});
